module.exports = "/static/assets/25d1e4a6a9db8d03fa8f5878e45d26c7.png";